import ChatHeader from './ChatHeader';
import MessageList from './MessageList';
import { VisitorResponse } from '../types';

interface ChatContainerProps {
  visitor: VisitorResponse;
  onFlagChange: (isFlagged: boolean) => void;
}

export default function ChatContainer({
  visitor,
  onFlagChange,
}: ChatContainerProps) {
  return (
    <div className="flex flex-col h-full bg-white">
      <ChatHeader visitor={visitor} onFlagChange={onFlagChange} />
      <MessageList visitorId={visitor.visitor_id} />
    </div>
  );
}
